import { render, staticRenderFns } from "./MyCompany.vue?vue&type=template&id=a6be3dc6&scoped=true&"
import script from "./MyCompany.vue?vue&type=script&lang=js&"
export * from "./MyCompany.vue?vue&type=script&lang=js&"
import style0 from "./MyCompany.vue?vue&type=style&index=0&id=a6be3dc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6be3dc6",
  null
  
)

export default component.exports